/* Promotions (Configuración del tema → Promociones): JS side of
   snippets/first-purchase-price.liquid, for prices that change after load
   (variant change on the product page). Same rule,
   rounding and markup as the snippet: keep both in sync. Data:
   window.FirstPurchase, printed in layout/theme.liquid, with the
   promotions this visitor can get (first: only for a customer who
   qualifies). The name stayed from when it was only the first purchase. */
(function () {
  var fp = window.FirstPurchase;
  if (!fp) return;

  // The promotion a piece gets ({ percent, minCents, label }), or null: the
  // first purchase if the customer qualifies and the piece reaches its
  // minimum; otherwise the seasonal discount, if on and the piece reaches
  // its minimum. ">=": a piece at the minimum gets it (minimum 0: every piece).
  fp.promo = function (cents) {
    if (typeof cents !== 'number') return null;
    if (fp.first && cents >= fp.first.minCents) return fp.first;
    if (fp.season && cents >= fp.season.minCents) return fp.season;
    return null;
  };

  // Final price in cents, or null when no promotion applies
  fp.discounted = function (cents) {
    var promo = fp.promo(cents);
    return promo ? cents - Math.round(cents * promo.percent / 100) : null;
  };

  // Updates a price box: fills its [data-fp-promo] slot and toggles
  // .fp-active, which strikes the current price and hides the compare price.
  fp.apply = function (box, cents) {
    if (!box) return;
    var promo = fp.promo(cents);
    var slot = box.querySelector('[data-fp-promo]');
    box.classList.toggle('fp-active', promo !== null);
    if (!slot) return;
    slot.textContent = '';
    if (promo === null) return;

    var priceEl = document.createElement('span');
    priceEl.className = 'fp-price';
    priceEl.innerHTML = Shopify.formatMoney(fp.discounted(cents), fp.moneyFormat); // money format may contain HTML
    var labelEl = document.createElement('span');
    labelEl.className = 'fp-label';
    labelEl.textContent = promo.label;
    slot.appendChild(priceEl);
    slot.appendChild(document.createTextNode(' '));
    slot.appendChild(labelEl);
  };
})();
